import * as yup from 'yup';
import { buildDefaults } from '../shared/campaignDefaults';
import { hasBaseErrors, hasInvalidAnnualDelay } from '../shared/primaryActionChecks';
import { commonSchemaShape, withMessageOrderTest } from '../shared/validationSchema';
import { withoutMessageTime } from '../shared/payloadMessages';
import { CampaignTypeSpec, whenVisible } from '../policy';
import { policyIssue } from '../issues';

export const annualSpec: CampaignTypeSpec = {
  externalType: 'birthday',
  scheduleKind: 'annual',
  defaultScheduledType: 'delay',

  fields: config => [
    'name',
    'contactDateType',
    ...whenVisible(config.keywords, 'keywords'),
    ...whenVisible(config.recipients, 'recipients'),
    'messages',
    ...whenVisible(config.opt_out_message, 'optOut'),
  ],

  defaults: config => ({
    ...buildDefaults(config, { scheduledType: 'delay', delay: '0m' }),
    metadataName: '',
  }),

  fromCampaign: (base, campaign) => ({
    ...base,
    metadataName: campaign.scheduledMessages?.[0]?.metadataName ?? '',
  }),

  issues: (values, config) => policyIssue(
    hasBaseErrors(values, config) || hasInvalidAnnualDelay(values),
    'annual-primary-blocked',
  ),

  payload: ({ base, values }) => ({
    ...base,
    scheduledMessages: withoutMessageTime(base.scheduledMessages)
      .map(message => ({ ...message, dataCapture: undefined, metadataName: values.metadataName })),
  }),

  schema: config => withMessageOrderTest(
    yup.object(commonSchemaShape(config, { messages: true })),
  ),
};
